module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2z"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_c('em', [_vm._v("3")])])]), _c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('em', [_vm._v("Condiments "), _c('span', {
    staticClass: "small"
  }, [_vm._v("and")]), _vm._v(" Sauces")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As with the spice blends in the previous chapter, low sodium varieties of these items are available. But they are often more difficult to find, available only online or in specialty stores. The good news is they are often really easy to make yourself. And you may find that you like the flavor of yours even better than the ones you buy.")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "ch03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Barbecue Sauce")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This is a quick-to-make barbecue sauce that starts with low sodium ketchup. It’s tomatoey and relatively sweet, and the spices have a basic chili flavor. In other words, not too different from most bottled sauces.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("½ cup (120 g) low sodium ketchup")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (120 ml) vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (170 g) honey")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (85 g) molasses")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon chili powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dry mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Combine all ingredients and mix well. Store in a covered jar in the refrigerator.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 10 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 24 g water; 97 calories (2% from fat, 2% from protein, 96% from carb); 1 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 25 g carb; 1 g fiber; 22 g sugar; 27 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("8 mg sodium")]), _vm._v("; 228 mg potassium; 367 IU vitamin A; 3 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Cherry Barbecue Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("We use this often on pork ribs. It makes them just the way I like them, sweet and sticky.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 cup (240 g) low sodium ketchup")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("12 ounces (340 g) cherry cola")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (80 g) cherry preserves")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon dry mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon hot pepper sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon ground ginger")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Combine all ingredients in a saucepan. Simmer over low heat 20 minutes, until slightly thickened.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 16 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 31 g water; 39 calories (2% from fat, 3% from protein, 96% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 10 g carb; 0 g fiber; 8 g sugar; 5 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("7 mg sodium")]), _vm._v("; 77 mg potassium; 161 IU vitamin A; 3 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("Tip:")]), _vm._v(" Don’t use diet soda—real sugar deals with the grilling much better.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Chicago Barbecue Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This sauce, made from fresh vegetables, is sweet and not too spicy. I’m told it’s similar to ones served in Chicago restaurants.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 teaspoon vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ½ cups (240 g) red onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("3 cups (540 g) tomatoes, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¾ teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ½ teaspoons sweet paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon chili powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ½ teaspoons Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (120 ml) orange juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Heat the oil in a saucepan and sauté onion until translucent. Add the remaining ingredients, except orange juice; stir well and bring to a boil. Reduce heat and simmer for 10 minutes. Remove from heat, let cool, and add orange juice. Puree sauce in a blender or food processor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 32 servings")])]), _c('p', {
    staticClass: "noindentn"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('strong', [_vm._v("Nutritional Analysis")])])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 24 g water; 13 calories (33% from fat, 8% from protein, 59% from carb); 0 g protein; 1 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 2 g carb; 0 g fiber; 1 g sugar; 5 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("4 mg sodium")]), _vm._v("; 68 mg potassium; 316 IU vitamin A; 5 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("KC Barbecue Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This sauce is similar to KC Masterpiece, thick and sweet. The liquid smoke gives it a smoky flavor even before you put it on the grill.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 cup (240 g) low sodium ketchup")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 cup (245 g) no-salt-added tomato sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅔")]), _vm._v(" cup (150 g) brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅔")]), _vm._v(" cup (157 ml) red wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (85 g) molasses")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) liquid smoke")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon chili powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon celery seed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon black pepper, coarsely ground")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large saucepan over medium heat, mix together the ketchup, tomato sauce, brown sugar, wine vinegar, molasses, and liquid smoke. Add garlic powder, onion powder, chili powder, paprika, celery seed, cinnamon, cayenne pepper, and black pepper. Reduce heat to low and simmer for up to 20 minutes. For thicker sauce, simmer longer, and for thinner, less time is needed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 24 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 23 g water; 49 calories (1% from fat, 2% from protein, 96% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 13 g carb; 0 g fiber; 11 g sugar; 17 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("7 mg sodium")]), _vm._v("; 169 mg potassium; 180 IU vitamin A; 3 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("Bourbon Barbecue Sauce")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This sauce is a variation of one on the back of the Jack Daniel’s Wood Smoking Chips bag. It’s not very sweet but gives pork or chicken a nice flavor. This sauce should only be used during the last half hour or so or cooking, since it tends to get pretty black and crispy if cooked too long.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("½ cup (120 ml) Jack Daniel’s whiskey or other bourbon whiskey")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (120 g) low sodium ketchup")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon dry mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all ingredients together. Brush on meat while cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 8 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 23 g water; 52 calories (3% from fat, 5% from protein, 91% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 5 g carb; 0 g fiber; 4 g sugar; 3 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("6 mg sodium")]), _vm._v("; 84 mg potassium; 157 IU vitamin A; 4 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("North Carolina Barbecue Sauce")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This sauce is similar to the ones found in eastern North Carolina. Based on vinegar and red pepper, it tends to be hot and sour but is perfect for a pulled pork sandwich with coleslaw.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("½ cup (120 ml) cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (120 ml) white vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon hot pepper sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Combine the cider vinegar, white vinegar, brown sugar, cayenne pepper, hot pepper sauce, and pepper in a jar or bottle with a tight-fitting lid. Refrigerate for 1 to 2 days before using so that the flavors will blend. Shake occasionally and store for up to 2 months in the refrigerator.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 16 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 15 g water; 6 calories (4% from fat, 2% from protein, 94% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 2 g carb; 0 g fiber; 2 g sugar; 2 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("3 mg sodium")]), _vm._v("; 23 mg potassium; 76 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Asian Barbecue Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This sauce is great on pork or chicken.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 cup (235 ml) Soy Sauce Substitute (see recipe, page 53)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 cup (235 ml) water")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("6 teaspoons (30 g) brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (3.6 g) ground ginger")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("4 teaspoons (20 ml) sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (6 g) garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon red pepper flakes")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("Combine all ingredients and store in a glass jar in the refrigerator for up to 2 weeks.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 16 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 16 g water; 31 calories (33% from fat, 0% from protein, 67% from carb); 0 g protein; 1 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 5 g carb; 0 g fiber; 5 g sugar; 6 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("2 mg sodium")]), _vm._v("; 24 mg potassium; 11 IU vitamin A; 0 mgvitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Chili Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("I’ve got to admit I’ve never been a really big fan of bottled chili sauce. The kids used it on hot dogs for a while, but I’ve always been a mustard and relish type of guy. Anyway, I much prefer the flavor of this chili sauce to the kind found in stores. There are enough veggies in it to give it something more than a glorified ketchup taste. It keeps well in the refrigerator for weeks, and you could freeze it if you wanted to.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 cups (475 ml) no-salt-added tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("8 ounces (230 g) no-salt-added tomato sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (80 g) onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (100 g) sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (50 g) celery, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (60 g) green bell pepper, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon molasses")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon hot pepper sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon cloves")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon dried basil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon dried tarragon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (120 ml) cider vinegar")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Combine all ingredients in a large saucepan. Bring to a boil, reduce heat, and simmer uncovered for 1 ½ hours or until the mixture is reduced to half its original volume.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 48 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 20 g water; 15 calories (2% from fat, 5% from protein, 94% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 4 g carb; 0 g fiber; 3 g sugar; 6 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("3 mg sodium")]), _vm._v("; 56 mg potassium; 39 IU vitamin A; 3 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Steak Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Similar recipes for an A-1–type steak sauce clone show up on a number of websites. This one uses reduced-sodium ingredients to make it applicable to a low sodium diet.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("½ cup (120 ml) orange juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (82.5 g) raisins")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (60 ml) Soy Sauce Substitute (see recipe, page 53)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (60 ml) white vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 g) Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (60 g) low sodium ketchup")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon orange peel, grated")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bring all the ingredients to a boil, then boil for 2 minutes, stirring constantly. Remove from the heat. Allow the mixture to cool to lukewarm. Pour the mixture into a blender and blend until it is smooth. Pour it into a bottle and cap tightly. Refrigerate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 32 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 8 g water; 12 calories (4% from fat, 5% from protein, 91% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 3 g carb; 0 g fiber; 2 g sugar; 3 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 39 mg potassium; 25 IU vitamin A; 2 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("Fresh Salsa")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("I usually prefer “cooked” salsa to the fresh kind, but I have to admit this makes a great dip for unsalted tortilla chips or just to spoon over a piece of fish or chicken while it cooks.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 green bell pepper, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 red bell pepper, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 tomato, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (120 ml) lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon fresh basil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon fresh cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Hot pepper flakes, optional")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Combine all ingredients in a small bowl. Let stand for 20 minutes before serving. Add hot pepper flakes if desired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 16 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 40 g water; 12 calories (5% from fat, 11% from protein, 84% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 3 g carb; 1 g fiber; 1 g sugar; 8 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 83 mg potassium; 431 IU vitamin A; 29 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Dick’s Best Salsa")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("It took me a while, but I finally came up with a recipe for salsa that satisfies me—and I actually wrote down the ingredients while I was concocting it. It passed the taste test when a whole pint jar disappeared into the young people who attended my daughter’s college graduation party, so I guess it’s okay. This makes a mild version. You could add another chile pepper or two depending on how hot you like it.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("3 pounds (1.4 kg) plum tomatoes, peeled and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (50 g) black beans, cooked")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (65 g) frozen corn")])]), _c('p', {
    staticClass: "noindentr"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("8 ounces (230 g) no-salt-added tomato sauce")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 chile pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (60 ml) red wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (80 g) onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon minced garlic")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ½ teaspoons cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ½ teaspoons cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Combine all ingredients in a large pot. Simmer until desired thickness, about 15 minutes. Pack into jars and store in refrigerator. Makes about 3 pints (1.5 L).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 48 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 32 g water; 15 calories (7% from fat, 19% from protein, 74% from carb); 1 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 3 g carb; 1 g fiber; 1 g sugar; 7 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("2 mg sodium")]), _vm._v("; 110 mg potassium; 254 IU vitamin A; 6 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("Tip:")]), _vm._v(" To peel tomatoes, dip them into boiling water for about 30 seconds. The skins will come right off.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Guacamole")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This is really easy to make and very low in sodium.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 avocado, peeled and mashed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (6 g) onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon chopped chiles")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¾ cup (135 g) tomato, peeled and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon white pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon cilantro")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("Combine all ingredients. Cover and refrigerate for 1 hour to allow flavor to develop.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 6 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 44 g water; 55 calories (68% from fat, 6% from protein, 27% from carb); 1 g protein; 5 g total fat; 1 g saturated fat; 3 g monounsaturated fat; 1 g polyunsaturated fat; 4 g carb; 2 g fiber; 1 g sugar; 8 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("4 mg sodium")]), _vm._v("; 204 mg potassium; 220 IU vitamin A; 9 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Enchilada Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This makes a not-too-spicy, tomatoey sauce that is good on tacos as well as a cooking sauce for enchiladas and other baked Mexican dishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 medium onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (5 g) chili powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 cups (475 ml) no-salt-added tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 cups (475 ml) water")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Simmer all ingredients together in a saucepan for 1 hour, or until desired thickness.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 16 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 65 g water; 17 calories (36% from fat, 10% from protein, 54% from carb); 0 g protein; 1 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 3 g carb; 1 g fiber; 1 g sugar; 14 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("5 mg sodium")]), _vm._v("; 98 mg potassium; 318 IU vitamin A; 5 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("Fajita Marinade")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Marinate chicken or beef in this, then grill and slice thinly for easy fajitas. The only other things you need are some sautéed onions and peppers and some low sodium tortillas.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("¼ cup (60 ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (60 ml) red wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix ingredients together and use to marinate beef or chicken for at least 6 hours or overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 8 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 15 g water; 70 calories (84% from fat, 2% from protein, 14% from carb); 0 g protein; 7 g total fat; 1 g saturated fat; 5 g monounsaturated fat; 1 g polyunsaturated fat; 3 g carb; 0 g fiber; 1 g sugar; 11 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("17 mg sodium")]), _vm._v("; 69 mg potassium; 47 IU vitamin A; 10 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("Soy Sauce Substitute")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("No, it’s not real soy sauce. But I think you might be surprised how little you’ll notice the difference from the 300-mg-minimum-per-tablespoon stuff. This was sent to me by a reader of my email newsletter, who said it came from a")]), _vm._v(" Better Homes and Gardens "), _c('em', [_vm._v("low sodium cookbook. Ironically, that must be the only book they ever published that I don’t have. I usually make a double or triple batch. It keeps well in the refrigerator, and a half a cup never seems to go very far.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 tablespoons (28 ml) sodium-free beef bouillon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) red wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon molasses")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon ground ginger")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Dash black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Dash garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¾ cup (175 ml) water")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a small saucepan, combine all ingredients and boil gently, uncovered, for about 5 minutes or until the mixture is reduced to ½ cup (120 ml). Store in the refrigerator. Stir before using.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 8 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 24 g water; 11 calories (21% from fat, 11% from protein, 68% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 2 g carb; 0 g fiber; 1 g sugar; 6 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("22 mg sodium")]), _vm._v("; 21 mg potassium; 10 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Duck Sauce")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This very low sodium version of the classic Chinese condiment is really simple to make, since it starts with canned preserves.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 cup (320 g) plum preserves")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (160 g) apricot preserves")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 tablespoons (40 g) honey")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅔")]), _vm._v(" cup (157 ml) cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 clove garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix the ingredients in a saucepan; bring to a boil over medium heat. Cook for 5 minutes, stirring constantly. Store in a sterilized jar in the refrigerator.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 20 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 16 g water; 72 calories (0% from fat, 1% from protein, 99% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 18 g carb; 0 g fiber; 15 g sugar; 6 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("9 mg sodium")]), _vm._v("; 28 mg potassium; 16 IU vitamin A; 2 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Hoisin Sauce Substitute")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Another common Chinese condiment. This one can be used to add flavor to any stir-fry as well as in barbecue sauces and other uses.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 cup (235 ml) Soy Sauce Substitute (see recipe, page 53)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 clove garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried red pepper flakes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 g) low sodium ketchup")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon water, boiling")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried orange peel")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a bowl, combine the soy sauce substitute, garlic, pepper, and ketchup. In a second bowl, combine the remaining ingredients. Let stand 15 minutes. Pour the second bowl into soy sauce mixture, blending thoroughly. Pour into jars. Cover and refrigerate.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 18 servings")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 10 g water; 6 calories (36% from fat, 7% from protein, 58% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 0 g fiber; 1 g sugar; 1 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 26 mg potassium; 277 IU vitamin A; 16 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Teriyaki Sauce Substitute")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("A typical Chinese/Japanese condiment that you can make on your own. If you don’t have gingerroot, get some … or use 1/2 teaspoon of ground ginger.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 cup (235 ml) Soy Sauce Substitute (see recipe, page 53)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) sake")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (100 g) sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("3 cloves garlic, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon gingerroot, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Dash black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Combine all ingredients in a saucepan and heat until sugar is dissolved. Store in the refrigerator.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 20 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 1 g water; 35 calories (36% from fat, 0% from protein, 63% from carb); 0 g protein; 1 g total fat; 0 g saturated fat; 1 g monounsaturated fat; 1 g polyunsaturated fat; 5 g carb; 0 g fiber; 5 g sugar; 1 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("0 mg sodium")]), _vm._v("; 4 mg potassium; 0 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("Tip:")]), _vm._v(" You can substitute sherry or mirin, a sweet Japanese rice wine, for the sake.")])])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Sweet and Sour Sauce")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This sauce can be used either on meat and vegetables or as a dipping sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅓")]), _vm._v(" cup (80 ml) white vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (115 g) brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("4 teaspoons (21 g) no-salt-added tomato paste")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¾ cup (175 ml) water, divided")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (3 g) cornstarch")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix together the vinegar, sugar, tomato paste, and 1/2 cup (120 ml) of the water. Bring to a boil in a small saucepan. Stir together the cornstarch and remaining water. Add to the other ingredients and continue cooking and stirring until thickened.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 6 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 51 g water; 90 calories (0% from fat, 2% from protein, 97% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 23 g carb; 1 g fiber; 20 g sugar; 21 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("19 mg sodium")]), _vm._v("; 188 mg potassium; 166 IU vitamin A; 2 mg vitamin C; 0 mg")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("Tip:")]), _vm._v(" If you are adding pineapple to the dish, replace part of the water with the pineapple juice.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Oyster Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("A low sodium version of the traditional Chinese sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("16 ounces (455 g) oysters")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ½ cups (355 ml) water, divided")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ½ teaspoons low sodium chicken bouillon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) Soy Sauce Substitute (see recipe, page 53)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon black pepper")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("Drain the oysters, reserving the liquid. In a preheated wok or skillet, combine the oysters, lemon juice, and ½ cup (120 ml) of the water. Poach for 15 seconds. Transfer to a blender and grind coarsely. In the wok, combine the bouillon and remaining water. Turn the heat to medium and bring to a slow boil. Turn to low and stir in the oyster mixture and remaining ingredients. Simmer for 5 minutes, stirring occasionally. Transfer to bottles or other containers. May be stored in the refrigerator for up to a week or frozen.")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 44 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 17 g water; 6 calories (23% from fat, 35% from protein, 42% from carb); 1 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 0 g fiber; 0 g sugar; 5 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("27 mg sodium")]), _vm._v("; 15 mg potassium; 8 IU vitamin A; 1 mg vitamin C; 3 mg cholesterol")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("Tip:")]), _vm._v(" A convenient way to store this sauce is to freeze it in ice cube trays so that you can take out a small quantity at a time.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Chinese Mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("There is nothing particularly fancy or difficult about making Chinese mustard. You just stir it up and let it sit to build up flavor.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("¼ cup (36 g) dry mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (60 ml) water, boiling")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Combine mustard and sugar; stir in water and oil. Let stand 8 hours before serving. Store in refrigerator.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 16 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 4 g water; 9 calories (74% from fat, 9% from protein, 17% from carb); 0 g protein; 1 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 0 g carb; 0 g fiber; 0 g sugar; 3 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("0 mg sodium")]), _vm._v("; 7 mg potassium; 3 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("Fish Sauce")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("A sauce used in many Asian recipes.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 cups (475 ml) water")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 pound (455 g) flounder fillets")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) low sodium chicken bouillon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon low sodium beef bouillon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 cup (235 ml) Fish Stock (see recipe, page 75)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cornstarch")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a wok, combine the water and the fish. Bring to a slow boil, cover, and boil for 5 minutes. Remove from the heat and let stand for 10 minutes. Pour into a blender and puree. Return to the wok. Add the bouillon and bring to a boil. Reduce heat and simmer for 5 minutes. In a bowl, combine the fish stock and cornstarch. Stir into the fish mixture and simmer until sauce thickens. May be refrigerated up to 2 weeks or frozen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 36 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 17 g water; 6 calories (10% from fat, 65% from protein, 26% from carb); 1 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 0 g carb; 0 g fiber; 0 g sugar; 1 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("18 mg sodium")]), _vm._v("; 20 mg potassium; 10 IU vitamin A; 0 mg vitamin C; 2 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Tartar Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("A lower-sodium version of this condiment with a flavor that many people seem to prefer to the bottled kind.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 cup (225 g) low sodium mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (40 g) onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (60 g) sweet pickle relish")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Combine all ingredients. Allow to stand in the refrigerator several hours or overnight before using.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 24 servings")])]), _c('p', {
    staticClass: "noindentn"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('strong', [_vm._v("Nutritional Analysis")])])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 5 g water; 70 calories (92% from fat, 1% from protein, 7% from carb); 0 g protein; 7 g total fat; 1 g saturated fat; 2 g monounsaturated fat; 3 g polyunsaturated fat; 1 g carb; 0 g fiber; 0 g sugar; 2 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("24 mg sodium")]), _vm._v("; 6 mg potassium; 30 IU vitamin A; 0 mg vitamin C; 5 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This makes a good general-purpose kind of mustard.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("¼ cup (36 g) dry mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (60 ml) white wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (60 ml) white wine")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 egg yolk")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Blend together all the ingredients except the egg yolk and let stand for 2 hours. Beat the egg yolk into the mixture. Cook, stirring constantly, until slightly thickened, about 5 minutes. Store covered in the refrigerator.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 36 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" Each with: 7 g water; 5 calories (29% from fat, 36% from protein, 35% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 0 g carb; 0 g fiber; 0 g sugar; 3 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("5 mg sodium")]), _vm._v("; 14 mg potassium; 12 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("Tip:")]), _vm._v(" If you like mustard less hot, heat the vinegar to almost boiling before mixing the ingredients together.")])])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("Spicy Brown Mustard")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Mustard is one of those things that typically has added salt but doesn’t seem to suffer from the lack of it. This particular mustard is similar to the coarse-ground French mustard like Grey Poupon Country French.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅓")]), _vm._v(" cup (59 g) mustard seeds")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅓")]), _vm._v(" cup (48 g) dry mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅔")]), _vm._v(" cup (157 ml) water, boiling")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 cup (235 ml) cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("3 teaspoons (15 ml) light corn syrup")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 g) brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon ground allspice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon ground cloves")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a small bowl, combine the mustard seeds, dry mustard, and boiling water. Stir to mix and set aside for 10 minutes. In a saucepan, combine the remaining ingredients and bring to a boil. Reduce the heat and simmer, covered, for 5 minutes. Remove from heat. Place mustard and vinegar mixtures in a blender and process at high speed until seeds are crushed. Place in a pint jar and store in the refrigerator. Can be used immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 96 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 4 g water; 7 calories (26% from fat, 11% from protein, 63% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 0 g fiber; 1 g sugar; 5 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 10 mg potassium; 1 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Honey Mustard Sauce")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("You can use this when grilling either fish, chicken, or pork to give a sweet and slightly spicy taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("¼ cup (85 g) honey")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 g) mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix ingredients together. Brush over meat when grilling or roasting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 4 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 17 g water; 72 calories (3% from fat, 2% from protein, 95% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 19 g carb; 0 g fiber; 18 g sugar; 9 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("4 mg sodium")]), _vm._v("; 35 mg potassium; 10 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("Cabernet Sauce")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This sauce is great served over steak. If you panfry the steak, you could use the same pan for the sauce, adding extra flavor.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("Olive oil spray")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (40 g) shallots, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¾ cup (53 g) mushrooms, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (120 ml) Cabernet Sauvignon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (60 ml) low sodium chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Black pepper, to taste")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Spray a medium-size nonstick skillet with olive oil spray. Over medium heat, sauté the shallots and mushrooms until softened, 4 to 5 minutes. Add the flour to the skillet and mix with vegetables until dissolved. Raise the heat and add the wine. Cook for 1 minute. Add the broth and thyme. Cook for 4 minutes to reduce liquid and thicken. Add pepper to taste. Spoon sauce over steak.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 2 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 122 g water; 83 calories (5% from fat, 19% from protein, 76% from carb); 2 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 9 g carb; 1 g fiber; 1 g sugar; 44 mg calcium; 3 mg iron; "), _c('strong', [_vm._v("22 mg sodium")]), _vm._v("; 257 mg potassium; 295 IU vitamin A; 3 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Roasted Garlic")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Roasted garlic is the hot new ingredient in packaged mixes as well as restaurant menus. It adds a mild garlic flavor without being overpowering. And it’s easy to make at home, even without one of the clay garlic roasters that you’ll see advertised.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 whole garlic pod")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 tablespoon (15 ml) olive oil")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("Hold pod of garlic on the side, take a sharp knife, and cut the pod about 1/4 inch (0.64 cm) from the top all the way across, exposing the raw garlic cloves. Place on a baking sheet covered with aluminum foil. Pour and rub in olive oil in to the top of the garlic. Bake in a 325°F (170°C, gas ")]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("mark 3) oven for 45 minutes to 1 hour or until garlic is soft; remove and let cool. Separate each garlic clove from the pod and pinch at the stem end to remove the garlic paste. Cover and refrigerate.")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 8 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 15 calories (96% from fat, 1% from protein, 3% from carb); 0 g protein; 2 g total fat; 0 g saturated fat; 1 g monounsaturated fat; 0 g polyunsaturated fat; 0 g carb; 0 g fiber; 0 g sugar; 1 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("0 mg sodium")]), _vm._v("; 1 mg potassium; 0 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Pizza Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Can’t find any low sodium pizza sauce on your grocer’s shelves? No problem—it’s easy to make your own.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 teaspoons (10 ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (40 g) onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried basil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 cup (245 g) no-salt-added tomato sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (11 g) no-salt-added tomato paste")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a medium saucepan, sauté the garlic and onion in olive oil until tender. Add the oregano, basil, and black pepper and continue cooking a few more minutes. Stir in the tomato sauce and then the tomato paste. Simmer on low heat for about 10 minutes. Makes about 1 1/2 cups (365 g).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 12 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 24 g water; 33 calories (62% from fat, 6% from protein, 32% from carb); 0 g protein; 2 g total fat; 0 g saturated fat; 2 g monounsaturated fat; 0 g polyunsaturated fat; 3 g carb; 1 g fiber; 1 g sugar; 9 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("5 mg sodium")]), _vm._v("; 115 mg potassium; 124 IU vitamin A; 4 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("Sun-Dried Tomato Spaghetti Sauce")])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("The sun-dried tomatoes give this a little different flavor than most spaghetti sauces. I generally buy the packages of dehydrated tomatoes, but you can also buy the oil-packed ones. The sodium level is about the same and you can skip the soaking step.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("½ cup (27.5 g) sun-dried tomatoes, dehydrated")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("8 ounces (230 g) no-salt-added tomato sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried basil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried parsley")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Soak the tomatoes in boiling water for 10 minutes. Drain. Place all ingredients in a skillet and simmer until the sauce is of desired thickness, about a half hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 4 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 65 g water; 54 calories (32% from fat, 11% from protein, 58% from carb); 2 g protein; 2 g total fat; 0 g saturated fat; 1 g monounsaturated fat; 0 g polyunsaturated fat; 9 g carb; 2 g fiber; 3 g sugar; 22 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("43 mg sodium")]), _vm._v("; 449 mg potassium; 425 IU vitamin A; 22 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Sun-Dried Tomato Pesto")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Serve this as a spread for Italian bread, on a sandwich, or mixed with warm pasta.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("¼ cup (35 g) walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (55 g) sun-dried tomatoes, oil packed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (25 g) Parmesan cheese, grated")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 clove garlic")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Black pepper, to taste")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 375°F (190°C, gas mark 5). Toast the nuts for 7 to 8 minutes; cool. Drain the oil from tomatoes. In a food processor, combine everything. Process until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 8 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 5 g water; 80 calories (79% from fat, 11% from protein, 10% from carb); 2 g protein; 7 g total fat; 1 g saturated fat; 4 g monounsaturated fat; 2 g polyunsaturated fat; 2 g carb; 1 g fiber; 0 g sugar; 38 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("61 mg sodium")]), _vm._v("; 132 mg potassium; 106 IU vitamin A; 7 mg vitamin C; 2 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Sun-Dried Tomato Vinaigrette")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Nice flavor—and a fair amount of fat, which I’ve not made any attempt to reduce.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("3 teaspoons (15 ml) white wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (14 g) sun-dried tomatoes, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 clove garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon white pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅓")]), _vm._v(" cup (80 ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Shake all ingredients together in a jar with a tight-fitting lid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 8 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 8 g water; 90 calories (91% from fat, 1% from protein, 8% from carb); 0 g protein; 9 g total fat; 1 g saturated fat; 7 g monounsaturated fat; 1 g polyunsaturated fat; 2 g carb; 0 g fiber; 1 g sugar; 3 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("12 mg sodium")]), _vm._v("; 66 mg potassium; 45 IU vitamin A; 5 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Basil Pesto")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This makes a fairly typical pesto, but without the usual added salt.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 cups (80 g) fresh basil, packed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("3 teaspoons (9 g) pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("3 cloves garlic, finely minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (25 g) Parmesan cheese, grated")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (120 ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Place basil leaves in small batches in food processor and whip until well chopped (do about 3/4 cup [30 g] at a time). Add about 1/3 of the nuts and garlic; blend again. Add about 1/3 of the Parmesan cheese; blend while slowly adding about 1/3 of the olive oil, stopping to scrape down sides of container. Process basil pesto until it forms a thick, smooth paste. Repeat until all ingredients are used; mix all batches together well. Serve over pasta. Basil pesto keeps in refrigerator 1 week, or freeze for a few months.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 12 servings")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 1 g water; 116 calories (81% from fat, 6% from protein, 13% from carb); 2 g protein; 11 g total fat; 2 g saturated fat; 7 g monounsaturated fat; 2 g polyunsaturated fat; 4 g carb; 2 g fiber; 0 g sugar; 141 mg calcium; 3 mg iron; "), _c('strong', [_vm._v("31 mg sodium")]), _vm._v("; 209 mg potassium; 536 IU vitamin A; 4 mg vitamin C; 1 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Fresh Vegetable Pasta Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("A quick and easy pasta sauce that will use up a few of those vegetables coming out of the garden. You can add some chicken or fish if you want or just serve it as a vegetarian main dish.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 teaspoons (10 ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 cloves garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon Italian seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 cups (360 g) tomatoes, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (60 g) green bell pepper, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 cup zucchini, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (80 g) onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (10 g) basil, fresh")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (2.6 g) parsley, fresh")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ cup (60 ml) white wine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large skillet, heat olive oil. Add lemon juice, garlic, Italian seasoning, and pepper. Cook until garlic starts to brown. Add vegetables, basil, and parsley and cook until softened. Remove from heat. Stir in wine. Toss with pasta.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 4 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 149 g water; 111 calories (58% from fat, 7% from protein, 35% from carb); 2 g protein; 7 g total fat; 1 g saturated fat; 5 g monounsaturated fat; 1 g polyunsaturated fat; 10 g carb; 3 g fiber; 4 g sugar; 81 mg calcium; 2 mg iron; "), _c('strong', [_vm._v("11 mg sodium")]), _vm._v("; 426 mg potassium; 1126 IU vitamin A; 32 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Cucumber Raita")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("No Indian meal is complete without raita. Use this cool condiment to dip your naan in or just as a way to cool off the heat of a spicy meal.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 cucumber, peeled and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 cup (230 g) plain low-fat yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ cup (15 g) mint leaves, fresh")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 ml) lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Combine the ingredients and refrigerate for several hours before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 6 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 90 g water; 36 calories (17% from fat, 27% from protein, 56% from carb); 3 g protein; 1 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 5 g carb; 1 g fiber; 4 g sugar; 91 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("31 mg sodium")]), _vm._v("; 192 mg potassium; 230 IU vitamin A; 4 mg vitamin C; 2 mg cholesterol")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c18b27f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 75
// module chunks = 0